
<v-dialog
    v-if       = "text"
    v-model    = "value"
    :max-width = "width"
    persistent
>
    <v-card>
        <v-card-title v-html="text"></v-card-title>
        <v-card-text v-html="subtext"></v-card-text>
        <div class="pl-5 pr-5" v-if="spinner">
            <v-progress-linear
                height = "6"
                color  = "primary"
                indeterminate
                rounded
            />
        </div>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                @click = "onCancel"
                color  = "primary"
                text
            >
                {{ $t('common.no') }}
            </v-btn>
            <v-btn
                @click = "onConfirm"
                color  = "primary"
                text
            >
                {{ $t('common.yes') }}
            </v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
